import React from 'react';

// Soft ambient light behind the glass cards (style B). Fixed, non-interactive.
// Drawn with radial gradients instead of huge blurred blobs: filter: blur(120px)
// on 700px layers under backdrop-filtered cards froze/crashed iPhone Safari.
export const GlowBackground = () => <div className="app-glow" aria-hidden="true" />;
